import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CONSTANTS } from 'src/app/constants';
import { AnalyzersService } from 'src/app/providers/services/analyzers.service';
import { ContainersService } from 'src/app/providers/services/containers.service';
import { MissionsService } from 'src/app/providers/services/missions.service';
import { NavigationService } from 'src/app/providers/services/navigation.service';
import { ParticipantsService } from 'src/app/providers/services/participants.service';
import { SkidsService } from 'src/app/providers/services/skids.service';
import { TeamsService } from 'src/app/providers/services/teams.service';
import { Mission } from 'src/app/storage/models/mission.model';

@Component({
    selector: 'app-mission-config-menu',
    templateUrl: './mission-config-menu.component.html',
    styleUrls: ['./mission-config-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MissionConfigMenuComponent implements OnInit, OnDestroy {

  mission: Mission | null = null;

  private missionSubscription: Subscription;
  private roomIdSubscription: Subscription;

  constructor(
    private missionsService: MissionsService,
    private navigationService: NavigationService,
    private containersService: ContainersService,
    private analyzersService: AnalyzersService,
    private skidsService: SkidsService,
    private teamsService: TeamsService,
    private participantsService: ParticipantsService
  ) { }

  ngOnInit(): void {
    this.missionSubscription = this.missionsService.selectedMission$.subscribe(async mission => {
      this.mission = mission;
      await this.participantsService.findAllByMissionId(mission.missionId);
    });
  }

  ngOnDestroy(): void {
    if (this.missionSubscription) { this.missionSubscription.unsubscribe(); }
    if (this.roomIdSubscription) { this.roomIdSubscription.unsubscribe(); }
  }

  async navigateToTeam(): Promise<void> {
    await this.navigationService.navigateFromMissionConfig(CONSTANTS.ROUTES.TEAM_CONFIG);
  }

  async navigateToProduct(): Promise<void> {
    await this.navigationService.navigateFromMissionConfig(CONSTANTS.ROUTES.PRODUCT_CONFIG);
  }

  async navigateToMaterial(): Promise<void> {
    await this.navigationService.navigateFromMissionConfig(CONSTANTS.ROUTES.MATERIAL_CONFIG);
  }

  async navigateToSupport(): Promise<void> {
    await this.navigationService.navigateFromMissionConfig(CONSTANTS.ROUTES.SUPPORT_CONFIG);
  }

  async navigateToParticipant(): Promise<void> {
    await this.navigationService.navigateFromMissionConfig(CONSTANTS.ROUTES.PARTICIPANTS_CONFIG);
  }


  getStatusClass(status: number, canBeBlocked: boolean): string {
    if (canBeBlocked && this.mission.checkingIsDone) { return "blocked"; }
    const STATUS = CONSTANTS.MISSION.CONFIG_STATUS;
    switch (status) {
      case STATUS.IN_PROGRESS:
        return "in-progress";
      case STATUS.COMPLETED:
        return "completed";
      case STATUS.BLOCKED:
        return "blocked";
      case STATUS.NOT_STARTED:
      default:
        return "not-started";
    }
  }

  getParticipantsStatusClass() {
    return (this.participantsService.participants$.getValue().length > 0) ? "in-progress" : "not-started";
  }

  getParticipantsStatus() {
    return (this.participantsService.participants$.getValue().length > 0) ? 2 : 1;
  }

  getTeamCount(): number {
    return this.teamsService.missionTeams$.getValue() ?
            this.teamsService.missionTeams$.getValue().length :
            0;
  }

  getProductCount(): number {
    return this.containersService.missionContainers$.getValue() ?
            this.containersService.missionContainers$.getValue().length :
            0;
  }

  getMaterialCount(): number {
    let count = 0;
    if (this.analyzersService.missionAnalyzers$.getValue()) {
      count += this.analyzersService.missionAnalyzers$.getValue().length;
    }
    if (this.skidsService.missionSkids$.getValue()) {
      count += this.skidsService.missionSkids$.getValue().length;
    }
    return count;
  }

  getSupportCount(): number {
    return this.teamsService.missionSupportTeams$.getValue() ?
            this.teamsService.missionSupportTeams$.getValue().length :
            0;
  }

  getParticipantCount(): number {
    return this.participantsService.participants$.getValue().length || 0;
  }
}
